import { useContext, createContext } from 'react';

import { AppConfigToolkitMba } from '@/graphql/generated';

/**
 * Omit theme and put another type because
 * Theme should have more optional fields that are not required in all em toolkits
 * but required in web-apps applications
 */

export const AppConfigContext = createContext<{
  appConfig: AppConfigToolkitMba | null;
}>({
  appConfig: null
});

export const useAppConfigContext = () => {
  const { appConfig } = useContext(AppConfigContext);

  if (!appConfig) {
    throw new Error(`Config couldn't be loaded`);
  }

  return appConfig;
};
